import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {suppliersServicesService} from '@store/suppliers/services/suppliers-services.service';
import {SuppliersServicesState} from '@store/suppliers/services/suppliers-services.store';

type SearchSuppliersServicesParams = Partial<SuppliersServicesState>

export const searchSuppliersServicesEffect = createEffectFn((params$: Observable<SearchSuppliersServicesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => suppliersServicesService.getSuppliersServices().pipe(catchError(() => EMPTY))),
  );
});
